import React, { forwardRef, ForwardRefRenderFunction, ReactNode } from 'react';
import classNames from 'classnames';
import ReCAPTCHA, { ReCAPTCHAProps } from 'react-google-recaptcha';
import env from 'env';
import utils from 'utils';

export type RecaptchaRef = ReCAPTCHA;

type RecaptchaProps = {
  className?: string;
  /** Rendered instead of the widget while server side generating. */
  ssgFallback?: ReactNode;
} & Omit<ReCAPTCHAProps, 'sitekey'>;

const Recaptcha: ForwardRefRenderFunction<RecaptchaRef, RecaptchaProps> = (
  props,
  ref,
) => {
  const { className, ssgFallback = null, ...rest } = props;

  const classes = classNames('recaptcha', className);

  if (utils.isSSG()) return <>{ssgFallback}</>;

  return (
    <ReCAPTCHA
      {...rest}
      ref={ref}
      className={classes}
      sitekey={env.ReCAPTCHA_KEY}
    />
  );
};

export default forwardRef(Recaptcha);
